import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Demo from "./pages/Demo";
import ChatLink from "./pages/ChatLink";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// openmy.chat is the customer-facing home of WhatsApp deep-link chats: tokens
// live at the ROOT there (openmy.chat/<token> — no /c/), and NOTHING else is
// served on that host: the tester/demo pages stay on the vercel.app host, and
// any junk path lands on ChatLink's clean "link isn't valid" screen instead of
// a 404. The vercel.app host keeps the long /c/:token form (already printed in
// approved templates), which also still works on openmy.chat.
const isChatLinkHost =
  typeof window !== "undefined" &&
  /(^|\.)openmy\.chat$/i.test(window.location.hostname);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {isChatLinkHost ? (
            <>
              <Route path="/c/:token" element={<ChatLink />} />
              <Route path="/:token" element={<ChatLink />} />
              {/* No token (bare host / junk paths) → ChatLink's error screen */}
              <Route path="*" element={<ChatLink />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Index />} />
              <Route path="/demo" element={<Demo />} />
              {/* WhatsApp deep-link chat — token minted by api/chat-link */}
              <Route path="/c/:token" element={<ChatLink />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </>
          )}
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
